import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlineOutlined';
import TimelineIcon from '@mui/icons-material/Timeline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import type { SuggestionOption } from '@openx/components-core/lib/AiChat/types';

import type { ConstValues } from '@openx/types/helpers';
export const FAILED_TO_SYNC_STATUS = 'FAILED_TO_SYNC';

export const TEMPORARY_CHAT_ID = 'temporary-chat';

export const SUGGESTION_OPTIONS: SuggestionOption[] = [
  {
    label: "What's Blocking This Deal?",
    description: 'Diagnose scaling blockers, how to increase Spend for this Deal?',
    message: "Why isn't this Deal spending more? Identify what's blocking it and provide actionable recommendations.",
    Icon: TrendingUpIcon,
  },
  {
    label: 'Full Deal Diagnosis',
    description: 'End-to-end check: funnel, loss reasons, recent trends and targeting.',
    message:
      'Run a full diagnosis of this Deal. Start with funnel to find the earliest bottleneck, then check bid loss reasons, then hourly performance over the last 48 hours. Correlate the findings with the active targeting setup and with recent configuration changes on the Deal or Package. Finish with prioritized actions to improve performance.',
    Icon: TroubleshootIcon,
  },
  {
    label: 'Analyze Drops/Spikes',
    description: 'Investigate recent spikes/drops in performance and setup changes.',
    message:
      'Investigate sudden spikes/drops in performance and recent changes in Deal setup, suggest actions to take.',
    Icon: TimelineIcon,
  },
  {
    label: 'Targeting vs Performance',
    description: 'Compare targeting vs performance, where is Deal underperforming?',
    message:
      "Compare this Deal's targeting against its performance. Is there traffic the Deal targets that isn't performing, and what should change?",
    Icon: AltRouteIcon,
  },
  {
    label: 'Loss Reasons Analysis',
    description: 'Analyze loss reasons in details, how to unblock the Deal.',
    message: 'Analyze loss reasons in details and provide recommendations on how to unblock the Deal.',
    Icon: AirlineStopsIcon,
  },
  {
    label: 'Where To Start?',
    description: "See what's available and pick a starting point.",
    message: 'What can you do? List the types of questions you can answer, grouped by topic.',
    Icon: HelpOutlineIcon,
  },
];

export type MessageActionState = {
  thumbUp: boolean;
  thumbDown: boolean;
  requestFeedback: boolean;
  feedbackSubmitted: boolean;
};

export const initialActionState: MessageActionState = {
  thumbUp: false,
  thumbDown: false,
  requestFeedback: false,
  feedbackSubmitted: false,
};

export const ActionType = {
  THUMB_UP: 'THUMB_UP',
  THUMB_DOWN: 'THUMB_DOWN',
  SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
} as const;

export type ActionTypeValue = ConstValues<typeof ActionType>;
